export default function SupportSection() {
  return (
    <>
      <p className="text-sm text-muted-foreground mb-3">
        If you cannot find the answer you need in this guide, here is how to get help:
      </p>
      <ul
        className="list-disc list-inside space-y-2 text-sm text-muted-foreground ml-2"
        role="list"
      >
        <li>
          <span className="font-medium">Ask your administrator</span> — They can help with account
          access, permissions, data questions, and configuration changes.
        </li>
        <li>
          <span className="font-medium">Submit an internal support request</span> — Use the{' '}
          <a
            href="/support-request"
            className="text-primary underline underline-offset-4 hover:text-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded"
          >
            Internal Support
          </a>{' '}
          form to submit bug reports, feature requests, access issues, and more. A ticket is created
          automatically.
        </li>
        <li>
          <span className="font-medium">Create a ticket directly</span> — If you prefer, create a
          ticket at{' '}
          <a
            href="/tickets/new"
            className="text-primary underline underline-offset-4 hover:text-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded"
          >
            Support &rarr; New Ticket
          </a>
          .
        </li>
        <li>
          <span className="font-medium">Request a feature</span> — Use the Enhancement Tracker
          (Admin access required) or share your idea with your administrator. Your feedback directly
          shapes what gets built next.
        </li>
      </ul>

      <section aria-labelledby="accessibility-heading" className="mt-4">
        <h3 id="accessibility-heading" className="font-semibold mb-2">
          Accessibility
        </h3>
        <p className="text-sm text-muted-foreground mb-2">
          Grackle CRM is designed to meet WCAG 2.2 AA accessibility standards. Every feature
          supports:
        </p>
        <ul
          className="list-disc list-inside space-y-1 text-sm text-muted-foreground ml-2"
          role="list"
        >
          <li>Full keyboard navigation (Tab, Enter, Escape, and arrow keys)</li>
          <li>Screen reader compatibility with semantic HTML and ARIA labels</li>
          <li>Visible focus indicators on all interactive elements</li>
          <li>Color contrast that meets the 4.5:1 minimum ratio</li>
          <li>Responsive design that works on desktop, tablet, and mobile</li>
        </ul>
        <p className="text-sm text-muted-foreground mt-2">
          If you experience any accessibility barriers, please report them to your administrator. We
          take accessibility seriously and will address issues promptly.
        </p>
      </section>
    </>
  )
}
